import { LegacyLanguageCode } from '../locale/language';
import { IUser } from './IUserState';

export interface IApiUser {
  id: string;
  eMail: string;
  lastLoginAt: string;
  firstName: string;
  lastName: string;
  roles: string[];
  isRegionFixed: boolean;
  languageCode: LegacyLanguageCode;
  creationLocked: boolean;
}

export function transformApiUser(user: IApiUser | null): IUser | null {
  if (!user) {
    return null;
  }
  return {
    id: user.id,
    email: user.eMail,
    firstName: user.firstName,
    lastName: user.lastName,
    roles: user.roles,
    language: user.languageCode,
    lastLoginAt: new Date(user.lastLoginAt),
    isRegionFixed: user.isRegionFixed,
    creationLocked: user.creationLocked,
  };
}
